import { useState } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Routes
} from "react-router-dom";
import './App.css';
import Footer from './Components/Footer';
import Header from './Components/Header';
import Page1 from './Components/Page1';
import Page2 from './Components/Page2';
import Page3 from './Components/Page3';
import Page4 from './Components/Page4';
import Page5 from './Components/Page5';

function App() {

  const [curr_page, setCurr_Page] = useState(<Page1 />);
  let arr_Pages = [<Page1 />, <Page2 />, <Page3 />, <Page4 />, <Page5 />];

  function incCnt(PageId) {
    setCurr_Page(arr_Pages[PageId]);
  }


  return (
    <div>
      <Router>
        <Header incCnt={(PageId) => incCnt(PageId)} />
        {curr_page}

        {/*
          <Routes>
            <Route path="/" element={<Page1 />} />
            <Route path="/skills" element={<Page2 />} />
            <Route path="/about" element={<Page3 />} />
            <Route path="/myapp" element={<Page4 />} />
            <Route path="/contact" element={<Page5 />} />
          </Routes>
          */
        }
      </Router>


      <Footer />

    </div>
  );
}

export default App;
